export default __webpack_public_path__ + "static/media/techsicoHeaderLogo.3ddb842b.svg";